import axios from 'axios';

import { parameters } from '../../constants/parameters';
import * as genericApi from './generic-api';
import { Badge } from '../../entities/badge';
import BadgeForm from '../../entities/form/badge';
import { Pagination } from '../../entities/pagination';

export const list = async (
  token: string,
  paramString?: object,
): Promise<{ items: Badge[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/badges-crud`;

  return genericApi.list<Badge>(token, url, { ...paramString, with: ['translations'] });
};

export const one = async (token: string, id: string): Promise<Badge> => {
  const url = `${parameters.api.baseUrl}/badges-crud/${id}?with[]=translations`;

  return genericApi.one<Badge>(token, url);
};

export const update = async (token: string, id: number, data: BadgeForm): Promise<Badge | undefined> => {
  const url = `${parameters.api.baseUrl}/badges-crud/${id}`;

  return genericApi.update<BadgeForm, Badge>(token, url, data);
};

export const create = async (token: string, data: BadgeForm): Promise<Badge | undefined> => {
  const url = `${parameters.api.baseUrl}/badges-crud`;

  return genericApi.create<BadgeForm, Badge>(token, url, data);
};

export const remove = async (token: string, id: number): Promise<{ status: string }> => {
  const url = `${parameters.api.baseUrl}/badges-crud/${id}`;

  const res = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });

  return res.data;
};
